import { supabase } from '../../lib/supabase';
import { ProviderVerification } from './ProviderVerification';

export function InsurerManagement() {
  return <ProviderVerification />;
}